import { render, staticRenderFns } from "./pay-transfer.vue?vue&type=template&id=6d3f5326&scoped=true"
import script from "./pay-transfer.vue?vue&type=script&lang=js"
export * from "./pay-transfer.vue?vue&type=script&lang=js"
import style0 from "./pay-transfer.vue?vue&type=style&index=0&id=6d3f5326&prod&lang=scss&scoped=true"
import style1 from "./pay-transfer.vue?vue&type=style&index=1&id=6d3f5326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3f5326",
  null
  
)

export default component.exports